import gql from 'graphql-tag';
export const Empty_Cart = gql`
  mutation emptyCartSeat($cartToken: String!) {
    emptyCartSeat(cart_token: $cartToken) {
      success
      message
    }
  }
`;
